import styled from '@emotion/styled';
import {Collapsible} from '@radix-ui/react-collapsible';
import {Button} from '@travel-frontend/ui-components';

import {Content} from '@/components/Collapsible/components/Content';

export const Container = styled(Collapsible, {
  shouldForwardProp: (propertyName) => propertyName !== 'hasFadeOut',
})`
  display: flex;
  flex-direction: column;

  &[data-state='open'] ${Content} ${Button} {
    margin-top: 8px;
  }
`;
